import { __assign, __extends } from "tslib";
import * as React from 'react';
import * as propTypes from 'prop-types';
var TableContextConsumer = /** @class */ (function (_super) {
    __extends(TableContextConsumer, _super);
    function TableContextConsumer(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.defaultTableContext = {
            colWidths: [],
        };
        _this.createConsumedContext = function () {
            var definedContext = Object.keys(_this.context).reduce(function (res, currKey) {
                var _a;
                var context = _this.context;
                return !!context[currKey] ? __assign(__assign({}, res), (_a = {}, _a[currKey] = context[currKey], _a)) : res;
            }, {});
            return __assign(__assign({}, _this.defaultTableContext), definedContext);
        };
        _this.context = context;
        return _this;
    }
    TableContextConsumer.prototype.render = function () {
        var ctx = this.createConsumedContext();
        return this.props.render(ctx);
    };
    TableContextConsumer.contextTypes = {
        colWidths: propTypes.arrayOf(propTypes.string)
    };
    return TableContextConsumer;
}(React.Component));
export { TableContextConsumer };
//# sourceMappingURL=consumer.js.map